import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useCart } from '../context/CartContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiHeart, FiCheck, FiStar } = FiIcons;

export default function ProductCard({ product, index }) {
  const { addToCart } = useCart();
  const [isAdding, setIsAdding] = useState(false);
  const [isWishlisted, setIsWishlisted] = useState(false);

  const handleAdd = () => {
    setIsAdding(true);
    addToCart(product);
    setTimeout(() => setIsAdding(false), 1000);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      className="group"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-zinc-100 mb-6 group">
        {product.stock === 0 && (
          <div className="absolute inset-0 z-20 bg-white/60 backdrop-blur-[2px] flex items-center justify-center">
            <span className="bg-zinc-900 text-white font-black px-6 py-2 uppercase tracking-widest text-[10px]">
              Sold Out
            </span>
          </div>
        )}
        
        {product.badge && product.stock > 0 && (
          <div className="absolute top-0 right-0 z-10 bg-red-600 text-white text-[10px] font-black px-4 py-2 uppercase tracking-widest">
            {product.badge}
          </div>
        )}
        
        <img 
          src={product.image} 
          alt={product.name}
          className={`w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-700 ${product.stock === 0 ? 'grayscale' : ''}`}
        />
        
        {product.stock > 0 && (
          <div className="absolute inset-0 bg-zinc-900/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4 gap-2">
            <button 
              onClick={handleAdd}
              disabled={isAdding}
              className={`w-full py-4 font-black text-xs tracking-widest uppercase transition-all duration-300 flex items-center justify-center gap-2 shadow-xl ${
                isAdding ? 'bg-green-600 text-white' : 'bg-zinc-900 text-white hover:bg-black'
              }`}
            >
              <SafeIcon icon={isAdding ? FiCheck : FiPlus} className="text-lg" />
              {isAdding ? 'ADDED TO CART' : 'ADD TO WORKSPACE'}
            </button>
          </div>
        )}

        <button 
          onClick={() => setIsWishlisted(!isWishlisted)}
          className={`absolute top-4 left-4 w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 backdrop-blur-sm ${
            isWishlisted ? 'bg-red-600 text-white' : 'bg-white/90 text-zinc-400 hover:text-red-500'
          }`}
        >
          <SafeIcon icon={FiHeart} className={isWishlisted ? 'fill-current' : ''} />
        </button>
      </div>

      <div className="space-y-2">
        <div className="flex justify-between items-baseline">
          <h3 className="font-black text-zinc-900 text-lg uppercase tracking-tight leading-tight">{product.name}</h3>
          <span className="font-bold text-zinc-900 shrink-0 ml-4">${product.price}</span>
        </div>
        <div className="flex items-center gap-1 mb-2">
          <SafeIcon icon={FiStar} className="text-amber-500 fill-current text-xs" />
          <span className="text-[10px] font-bold text-zinc-500">{product.rating} / 5.0</span>
        </div>
        <p className="text-sm text-zinc-500 leading-relaxed line-clamp-2">{product.description}</p>
      </div>
    </motion.div>
  );
}